module.exports = __webpack_public_path__ + "static/img/oakville3.b9cb5a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/oakville3.jpg
// module id = 116
// module chunks = 9